import React from 'react';
import { Box, Center, Text, Link, Image, IconButton } from '@chakra-ui/react';
import Slider from "react-slick";
import { FaInstagram } from 'react-icons/fa'

import ImagesFade from '@components/Common/ImagesFade';
import LazyImage from '@components/Common/LazyImage';
import WithAnimation from '@/components/Common/WithAnimation';
import 'slick-carousel/slick/slick.css';
import "slick-carousel/slick/slick-theme.css";


import { INVITATO_URL, SOUND_BY, SOUND_URL } from '@/constants';
import { BG_COVER, IMG_LOGO_ASPEDI, LOGO_INVITATO } from '@/constants/assets';
import { FOOTER_LINK_PROPS } from './types';
import { DATA_VENDOR } from './assets/index'
import { SUPPORT_VENDORS } from './support/index'

function FooterSection() {
  return (
    <Box bgColor="bgPrimary" width="100%">
      <Box bgImage={`url(${BG_COVER})`} bgSize="cover" textAlign="center" color="mainColorText" width="100%" position="relative">
        <Box padding="100px 32px">
          <WithAnimation>
            <Text margin="0" fontSize="sm" letterSpacing="2px">
              DIORGANISIR OLEH:
            </Text>
          </WithAnimation>
          <Center>
            <LazyImage src={IMG_LOGO_ASPEDI} maxWidth="200px" />
          </Center>
          <WithAnimation>
            <Text margin="32px 0 16px 0" fontSize="10px" letterSpacing="2px">
              DIDUKUNG OLEH:
            </Text>
          </WithAnimation>
          <Slider autoplay slidesToScroll={4} slidesToShow={4} dots arrows={false}>
            {SUPPORT_VENDORS.map((i, index) => {
              return (
                <Box background="transparent" margin="4px" key={index + 'sv'}>
                  <Center height="70px" margin="4px">
                    <Image maxHeight="100%" src={i.imgUrl} title={i.title} />
                  </Center>
                </Box>
              )
            })}
          </Slider>

          <WithAnimation>
            <Text margin="62px 0 16px 0" fontSize="10px" letterSpacing="2px">
              VENDOR PENDUKUNG:
            </Text>
          </WithAnimation>
          <Slider autoplay slidesToScroll={3} slidesToShow={3} dots arrows={false} rows={2}>
            {DATA_VENDOR.map((i, index) => {
              return (
                <Box background="transparent" margin="4px" key={index + `dv`}>
                  <Center height="70px" margin="4px">
                    <Image maxHeight="100%" src={i.imgUrl} title={i.title} />
                  </Center>
                </Box>
              )
            })}
          </Slider>
        </Box>
      </Box>
      {/* SLIDESHOW */}
      <Box>
        <ImagesFade />
        <Box fontWeight="light" color="mainColorText" padding="0 32px" textAlign="center" fontSize="md" margin="16px 0">
          <Text fontWeight="600">1 - 3 AGUSTUS 2022</Text>
          <Text margin="16px 0 32px 0" fontSize="sm">WORKSHOP | TALKSHOW | DEMO <br /> COACHING CLINIC | FASHION SHOW <br /> LIVE MUSIC</Text>
        </Box>
        <Text textAlign="center" color="mainColorText" fontSize="xs">
          Created with love by
        </Text>
        <Center>
          <Link href={INVITATO_URL} target="_blank">
            <LazyImage src={LOGO_INVITATO} maxWidth="100px" />
          </Link>
        </Center>
        <Center>
          <Link href={INVITATO_URL} target="_blank">
            <IconButton bgColor="bgSecondary" margin="8px 0 42px 0" isRound icon={<FaInstagram color="white" />} /></Link>
        </Center>
      </Box>
      {/* Title and Desc Section */}
      <Box bgColor="bgSecondary" padding="24px" textAlign="center">
        {/* INVITATO SECTION */}
        <Box>
          <Text {...FOOTER_LINK_PROPS}>
            {`© ${new Date().getFullYear()} Patra Wedding Expo. All Right Reserved`}
          </Text>
          <Link {...FOOTER_LINK_PROPS} href={SOUND_URL}>
            <Text>{`Song by ${SOUND_BY}`}</Text>
          </Link>
        </Box>
      </Box>
    </Box>
  );
}

export default React.memo(FooterSection);
